import { config } from "../config/siteConfig";
import { scrollToTarget } from "../lib/scroll";

const Footer = () => {
  const go = (e, href) => {
    e.preventDefault();
    scrollToTarget(href);
  };

  return (
    <footer
      data-testid="footer"
      className="bg-[#050E1C] text-white/50 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-10">
          <div>
            <p className="font-display text-white text-2xl tracking-[0.08em] leading-none">THE ECOM BIBLE</p>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">
              By {config.author.name}
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {config.nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => go(e, item.href)}
                data-testid={`footer-link-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40 hover:text-white transition-colors duration-300"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#get-the-book"
              onClick={(e) => go(e, "#get-the-book")}
              data-testid="footer-link-get-the-book"
              className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#D4AF37] hover:text-white transition-colors duration-300"
            >
              Get The Book
            </a>
          </nav>
        </div>
        <div className="mt-12 border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p data-testid="footer-copyright" className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
            © {new Date().getFullYear()} {config.brand.name} ·{" "}
            <a href={config.brand.url} target="_blank" rel="noreferrer" className="hover:text-white transition-colors duration-300">
              {config.brand.domain}
            </a>
            <span className="block mt-1 text-[#D4AF37]">{config.brand.tagline}</span>
          </p>
          <p className="font-mono text-[10px] tracking-[0.05em] text-white/30 max-w-md">
            {config.footer.disclaimer}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
